import * as CONST from './modalSettings'
import Moment from 'moment'
import { extendMoment } from 'moment-range'

const moment = extendMoment(Moment)

export const validate = (values, props) => {
  const errors = {}
  const { onboardingTimesList } = props
  const currentPickupRange = moment.range([
    moment(values.timeStart, CONST.TIME_FORMATS.HOURS_MINUTES),
    moment(values.timeStop, CONST.TIME_FORMATS.HOURS_MINUTES),
  ])
  const currentDay = values.day

  const getMinutes = value => (value ? value.split(':')[1] : '')

  if (values.timeStart) {
    const minutes = getMinutes(values.timeStart)
    if (minutes !== '00' && minutes !== '30') {
      errors.timeStart = 'Time value can be only round hours or half an hour'
    }
  }

  if (values.timeStop) {
    const minutes = getMinutes(values.timeStop)
    if (minutes !== '00' && minutes !== '30') {
      errors.timeStop = 'Time value can be only round hours or half an hour'
    }
  }

  if (
    moment(values.timeStart, CONST.TIME_FORMATS.HOURS_MINUTES).isAfter(
      moment(values.timeStop, CONST.TIME_FORMATS.HOURS_MINUTES),
    )
  ) {
    errors.timeStart = 'Invalid time range'
  }
  if (
    moment(values.timeStop, CONST.TIME_FORMATS.HOURS_MINUTES).isBefore(
      moment(values.timeStart, CONST.TIME_FORMATS.HOURS_MINUTES),
    )
  ) {
    errors.timeStop = 'Invalid time range'
  }
  if (
    moment(values.timeStop, CONST.TIME_FORMATS.HOURS_MINUTES).isSame(
      moment(values.timeStart, CONST.TIME_FORMATS.HOURS_MINUTES),
    )
  ) {
    errors.timeStop = 'Invalid time range'
  }

  // Is current time overlapping any of existing onboarding times by the given day
  onboardingTimesList &&
    onboardingTimesList.forEach(pickupTime => {
      const pickupTimeRange = moment.range([
        moment(pickupTime.timeStart, CONST.TIME_FORMATS.HOURS_MINUTES),
        moment(pickupTime.timeStop, CONST.TIME_FORMATS.HOURS_MINUTES),
      ])
      const day = pickupTime.day
      if (currentPickupRange.overlaps(pickupTimeRange) && currentDay == day) {
        errors.timeStop = 'Current date range overlaps existing one'
      }
    })

  return errors
}
